import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "..";

export interface ReminderQueueState {
  loading: boolean;
  error?: string | null;
  total?: number;
  past: any[];
  upcoming: any[];
}

const initialState: ReminderQueueState = {
  loading: false,
  error: null,
  total: 0,
  past: [],
  upcoming: [],
};

const slice = createSlice({
  name: "reminderQueue",
  initialState,
  reducers: {
    fetchReminderQueue: (state, _action: PayloadAction<any | undefined>) => {
      state.loading = true;
      state.error = null;
    },
    setReminderQueue: (state, action: PayloadAction<any>) => {
      state.loading = false;
      state.error = null;
      const res = action.payload || {};
      state.total = res.result?.total ?? res.total ?? 0;
      state.past = res.result?.past ?? res.past ?? [];
      state.upcoming = res.result?.upcoming ?? res.upcoming ?? [];
    },
    setReminderQueueError: (state, action: PayloadAction<string>) => {
      state.loading = false;
      state.error = action.payload;
    },
    clearReminderQueue: (state) => {
      state.loading = false;
      state.error = null;
      state.total = 0;
      state.past = [];
      state.upcoming = [];
    },
  },
});

export const {
  fetchReminderQueue,
  setReminderQueue,
  setReminderQueueError,
  clearReminderQueue,
} = slice.actions;

export const selectReminderQueue = (state: RootState) =>
  (state as any).reminderQueue as ReminderQueueState;

export default slice.reducer;
